import { del, get, post, put } from '@api/request';

export const fetchSearchOptions = async (
  { eventService },
  authenticationToken,
  { payload: { formID } },
) => {
  const url = `${eventService}/events/form/${formID}/searchconfig`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchEvents = async (
  { eventService },
  authenticationToken,
  { formID, page, pageSize, sortField, sortDirection, filterModel, payload },
) => {
  let url = `${eventService}/events/form/${formID}/search?page=${page}&pageSize=${pageSize}`;

  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }

  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach(filter => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }

  const { body } = await post(authenticationToken, url, payload);
  return Object.assign({}, body, { formID });
};

export const searchEventsStandalone = async (
  { eventService },
  authenticationToken,
  { data },
) => {
  let url = `${eventService}/events/form/${data.formID}/search`;
  const { body } = await post(authenticationToken, url, data.payload);
  return Object.assign({}, body, { formID: data.formID });
};

export async function fetchSearchStat(
  { eventService },
  authenticationToken,
  { formID, payload },
) {
  const url = `${eventService}/events/peventform/${formID}/statistics`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function exportEvents(
  { eventService },
  authenticationToken,
  { formID, data },
) {
  const url = `${eventService}/events/export/${formID}`;
  const { body } = await post(authenticationToken, url, data, {
    outputType: data.exportType === 'json' ? undefined : 'bytearray',
  });
  return body;
}

export async function fetchEventsSearchParams(
  { eventService },
  authenticationToken,
  { formID, userName },
) {
  const queryParam = userName ? `?userName=${userName}` : '';
  const url = `${eventService}/events/form/${formID}/searchparameters${queryParam}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertEventsSearchParam(
  { eventService },
  authenticationToken,
  { formID, payload },
) {
  const url = `${eventService}/events/form/${formID}/searchparameters`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateEventsSearchParam(
  { eventService },
  authenticationToken,
  { searchParamID, payload },
) {
  const url = `${eventService}/events/searchparameter/${searchParamID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteEventsSearchParam(
  { eventService },
  authenticationToken,
  { searchParamID },
) {
  const url = `${eventService}/events/searchparameter/${searchParamID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function duplicateEventsSearchParam(
  { eventService },
  authenticationToken,
  { searchParamID },
) {
  const url = `${eventService}/events/searchparameter/${searchParamID}/duplicate`;
  const { body } = await post(authenticationToken, url);
  return body;
}
